import React from "react"
import Numeral from "numeral"
import strings from "../../localization/strings"
import moment from "moment"
import { IAccountStats } from "../../models"
import { RaisedButton } from "material-ui"
import { amber500, grey50 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import * as utils from "../../helpers/utils"
interface IProps {
    billingData: IAccountStats
    calculateBillingByDevice: boolean
}

const AccountBillingForm: React.SFC<IProps> = (props: IProps) => {
    const getInt = value => {
        return Math.floor(value)
    }

    const getFloat = value => {
        const float = Math.floor(utils.roundToTwo(value - Math.floor(value)) * 100)
        return float === 0 ? "00" : float
    }

    const billingData = props.billingData
    const type = props.calculateBillingByDevice
    const currentMonthName = billingData.CurrentMonth
    const currentMonthYear = new Date().getFullYear()
    const oneMonthAgoMonthName = moment(new Date(currentMonthName + " 01 " + new Date().getFullYear()))
        .subtract(1, "month")
        .startOf("month")
        .format("MMMM")
    let oneMonthAgoYear = currentMonthYear
    if (oneMonthAgoMonthName === "December") oneMonthAgoYear = oneMonthAgoYear - 1
    const twoMonthsAgoMonthName = moment(new Date(currentMonthName + " 01 " + new Date().getFullYear()))
        .subtract(2, "month")
        .startOf("month")
        .format("MMMM")
    let twoMonthsAgoYear = currentMonthYear
    if (twoMonthsAgoMonthName === "December" || twoMonthsAgoMonthName === "November") twoMonthsAgoYear = twoMonthsAgoYear - 1

    const reportBillingDetail = (year: number, monthName: string) => {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        const referenceDate = moment().year(year).month(months.indexOf(monthName)).date(10).utc(true).startOf("day").format()

        const uri = api_url() + "/reporting/" + AccountStore.getCurrentAccount().Id + "/billing_report?referenceDate=" + utils.escapeDateTime(referenceDate)
        utils.checkIEBrowser() ? window.open(uri) : window.location.assign(uri)
    }

    return (
        <div className="AccountBillingForm" style={{ padding: "20px" }}>
            <div style={{ width: "33%", display: "inline-block", textAlign: "center", position: "relative" }}>
                <div className="billing-form-month">
                    {twoMonthsAgoMonthName} {twoMonthsAgoYear}
                </div>
                <div className="billing-form-large">{Numeral(billingData.TwoMonthsAgoTotalActiveEmployees).format("0,0")}</div>
                <div className="billing-form-small">{strings.ACTIVE_EMPLOYEES}</div>
                {type && (
                    <div>
                        <div className="billing-form-large">{Numeral(billingData.TwoMonthsAgoTotalActiveClocks).format("0,0")}</div>
                        <div className="billing-form-small">{strings.Active_Clocks.toUpperCase()}</div>
                        <div className="billing-form-medium">
                            <span className="currency">$</span>
                            <span>{Numeral(getInt(billingData.TwoMonthsAgoClockSubTotal)).format("0,0")}</span>
                            <span className="currency-float">.{getFloat(billingData.TwoMonthsAgoClockSubTotal)}</span>
                        </div>
                        <div className="billing-form-small">{strings.Clocks.toUpperCase()}</div>
                        <div className="billing-form-medium">
                            <span className="currency">$</span>
                            <span> {Numeral(getInt(billingData.TwoMonthsAgoEmployeeSubTotal)).format("0,0")}</span>
                            <span className="currency-float">.{getFloat(billingData.TwoMonthsAgoEmployeeSubTotal)}</span>
                        </div>
                        <div className="billing-form-small">{strings.Employees.toUpperCase()}</div>
                    </div>
                )}
                <hr style={{ border: "1px solid #b7b2b2" }} />
                <div className="billing-form-large">
                    <span className="currency-large">$</span>
                    <span>{Numeral(getInt(billingData.TwoMonthsAgoBillingTotal)).format("0,0")}</span>
                    <span className="currency-float-large">.{getFloat(billingData.TwoMonthsAgoBillingTotal)}</span>
                </div>
                <div className="billing-form-small">{strings.Monthly_Bill.toUpperCase()}</div>
                <RaisedButton
                    label={strings.Billing_Detail.toUpperCase()}
                    style={{ marginTop: 10 }}
                    backgroundColor={amber500}
                    labelColor={grey50}
                    labelStyle={{ paddingLeft: 10, paddingRight: 10, fontSize: 12 }}
                    onClick={() => reportBillingDetail(twoMonthsAgoYear, twoMonthsAgoMonthName)}
                />
            </div>
            <div style={{ width: "33%", display: "inline-block", textAlign: "center", position: "relative" }}>
                <div className="billing-form-month">
                    {oneMonthAgoMonthName} {oneMonthAgoYear}
                </div>
                <div className="billing-form-large">{Numeral(billingData.OneMonthAgoTotalActiveEmployees).format("0,0")}</div>
                <div className="billing-form-small">{strings.ACTIVE_EMPLOYEES}</div>
                {type && (
                    <div>
                        <div className="billing-form-large">{Numeral(billingData.OneMonthAgoTotalActiveClocks).format("0,0")}</div>
                        <div className="billing-form-small">{strings.Active_Clocks.toUpperCase()}</div>
                        <div className="billing-form-medium">
                            <span className="currency">$</span>
                            <span>{Numeral(getInt(billingData.OneMonthAgoClockSubTotal)).format("0,0")}</span>
                            <span className="currency-float">.{getFloat(billingData.OneMonthAgoClockSubTotal)}</span>
                        </div>
                        <div className="billing-form-small">{strings.Clocks.toUpperCase()}</div>
                        <div className="billing-form-medium">
                            <span className="currency">$</span>
                            <span> {Numeral(getInt(billingData.OneMonthAgoEmployeeSubTotal)).format("0,0")}</span>
                            <span className="currency-float">.{getFloat(billingData.OneMonthAgoEmployeeSubTotal)}</span>
                        </div>
                        <div className="billing-form-small">{strings.Employees.toUpperCase()}</div>
                    </div>
                )}
                <hr style={{ border: "1px solid #b7b2b2" }} />
                <div className="billing-form-large">
                    <span className="currency-large">$</span>
                    <span>{Numeral(getInt(billingData.OneMonthAgoBillingTotal)).format("0,0")}</span>
                    <span className="currency-float-large">.{getFloat(billingData.OneMonthAgoBillingTotal)}</span>
                </div>
                <div className="billing-form-small">{strings.Monthly_Bill.toUpperCase()}</div>
                <RaisedButton
                    label={strings.Billing_Detail.toUpperCase()}
                    style={{ marginTop: 10 }}
                    backgroundColor={amber500}
                    labelColor={grey50}
                    labelStyle={{ paddingLeft: 10, paddingRight: 10, fontSize: 12 }}
                    onClick={() => reportBillingDetail(oneMonthAgoYear, oneMonthAgoMonthName)}
                />
            </div>
            <div style={{ width: "33%", display: "inline-block", textAlign: "center", backgroundColor: "#e8e9ea", paddingBottom: 20, position: "relative" }}>
                <div className="billing-form-month">
                    {currentMonthName} {currentMonthYear}
                </div>
                <div className="billing-form-large">{Numeral(billingData.CurrentMonthTotalActiveEmployees).format("0,0")}</div>
                <div className="billing-form-small">{strings.ACTIVE_EMPLOYEES}</div>
                {type && (
                    <div>
                        <div className="billing-form-large">{Numeral(billingData.CurrentMonthTotalActiveClocks).format("0,0")}</div>
                        <div className="billing-form-small">{strings.Active_Clocks.toUpperCase()}</div>
                        <div className="billing-form-medium">
                            <span className="currency">$</span>
                            <span>{Numeral(getInt(billingData.CurrentMonthClockSubTotal)).format("0,0")}</span>
                            <span className="currency-float">.{getFloat(billingData.CurrentMonthClockSubTotal)}</span>
                        </div>
                        <div className="billing-form-small">{strings.Clocks.toUpperCase}</div>
                        <div className="billing-form-medium">
                            <span className="currency">$</span>
                            <span> {Numeral(getInt(billingData.CurrentMonthEmployeeSubTotal)).format("0,0")}</span>
                            <span className="currency-float">.{getFloat(billingData.CurrentMonthEmployeeSubTotal)}</span>
                        </div>
                        <div className="billing-form-small">{strings.Employees.toUpperCase()}</div>
                    </div>
                )}
                <hr style={{ border: "1px solid #b7b2b2" }} />
                <div className="billing-form-large">
                    <span className="currency-large">$</span>
                    <span>{Numeral(getInt(billingData.CurrentMonthBillingTotal)).format("0,0")}</span>
                    <span className="currency-float-large">.{getFloat(billingData.CurrentMonthBillingTotal)}</span>
                </div>
                <div className="billing-form-small">{strings.Monthly_Bill.toUpperCase()}</div>
                <RaisedButton
                    label={strings.Billing_Detail.toUpperCase()}
                    style={{ marginTop: 10 }}
                    backgroundColor={amber500}
                    labelColor={grey50}
                    labelStyle={{ paddingLeft: 10, paddingRight: 10, fontSize: 12 }}
                    onClick={() => reportBillingDetail(currentMonthYear, currentMonthName)}
                />
            </div>
        </div>
    )
}

export default AccountBillingForm
